// extracted by mini-css-extract-plugin
export default {"zoomModal":"N4-z","image":"O4-z","button":"P4-z","isOverlayShown":"Q4-z"};